import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import EntityStore from 'stores/EntityStore';
import APIUtil from 'util/APIUtil';
import BenchlingConfig from 'BenchlingConfig';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';

export function getOrgIdsWithUserJoinRequest() {
  if (EntityStore.currentUser() && EntityStore.currentUser().currentUserOutboundRequests) {
    return EntityStore.currentUser().currentUserOutboundRequests.map(
      (orgRequest) => orgRequest.organizationId
    );
  }
  return [];
}

export function hasSentRequestForOrg(orgId) {
  const requestedToJoinOrgs = getOrgIdsWithUserJoinRequest();
  return requestedToJoinOrgs.includes(orgId);
}

export function isTeam(entityId) {
  const type = APIUtil.apiIdToType(entityId);
  switch (type) {
    case ModelTypeConstants.TEAM:
      return true;
    default:
      assert(type === ModelTypeConstants.ENTITY, `Unexpected entity id: ${type}`);
      return false;
  }
}

function addSchemaTypes(schemaTypes) {
  let addedResponse = '';
  const lastSchema = schemaTypes.pop();
  if (schemaTypes.length > 1) {
    addedResponse += `${schemaTypes.join(', ')}, and `;
  } else if (schemaTypes.length === 1) {
    addedResponse += `${schemaTypes[0]} and `;
  }
  return `${addedResponse}${lastSchema} schemas`;
}

export function getTeamSchemaAdminSettingsCopy() {
  const activeSchemaTypesCreate = ['automation', 'result', 'request'];
  const activeSchemaTypesUpdate = ['request'];
  if (isFeatureEnabled({feature: ProcessesFeature.PROCESSES_ADMIN})) {
    activeSchemaTypesCreate.push('workflow');
    activeSchemaTypesUpdate.push('workflow');
  }
  if (!BenchlingConfig.PERMISSIONS_ENABLE_ASSAY_SCHEMA_PERMISSIONS) {
    activeSchemaTypesUpdate.push('automation', 'result');
  }
  if (activeSchemaTypesCreate.length === activeSchemaTypesUpdate.length) {
    return `Team members can create and update ${addSchemaTypes(activeSchemaTypesCreate)}`;
  }
  return `Team members can create ${addSchemaTypes(
    activeSchemaTypesCreate
  )}; team members can update ${addSchemaTypes(activeSchemaTypesUpdate)}`;
}
